import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './SubscriberDetails.scss';

class SubscriberDetails extends Component {
  subscriberData() {
    const { subscriber, job, block } = this.props;

    if (subscriber && job && block) {
      return {
        subscriber,
        jobId: job.send.job_id,
        emailName: job.send.email_name || '-',
        assetClass: block.asset_class.name,
        clicked: block.selection.wasClicked
      };
    }
    return {};
  }

  render() {
    const { formatMessage } = this.props.intl;

    const items = ['subscriber', 'jobId', 'emailName', 'assetClass', 'clicked'];
    const data = this.subscriberData();

    return (
      <div className="subscriber-details">
        <ul className="details-list">
          {items.map((item, idx) => {
            const label = formatMessage({
              id: `components.ecs.jobs.columns.${item}`
            });
            let value = data[item];
            if (value?.toString() === 'true' || value?.toString() === 'false') {
              const i18id = value ? 'common.yes' : 'common.no';
              value = formatMessage({ id: i18id });
            }

            return (
              <li key={`li-${idx}-${item}`}>
                <span>{label}</span>
                <span>{value}</span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

SubscriberDetails.contextTypes = {
  router: PropTypes.object
};

SubscriberDetails.propTypes = {
  actions: PropTypes.object,
  job: PropTypes.object,
  subscriber: PropTypes.string,
  block: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(SubscriberDetails);
